import * as React from "react";
import { forwardRef } from "react";
const SvgPathGreen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 12, viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 0L16.29 2.29L11.41 7.17L7.41 3.17L0 10.59L1.41 12L7.41 6L11.41 10L17.71 3.71L20 6V0H14Z", fill: "#2BCC93" }));
const ForwardRef = forwardRef(SvgPathGreen);
export { ForwardRef as ReactComponent };
